import { useDispatch } from 'react-redux'
import React, { useEffect, useRef, useState } from 'react';
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import { HiDotsHorizontal } from "react-icons/hi";
import { FaCalendarDay } from "react-icons/fa";
import { CustomLoader } from '../../../services/Reducer.js'
import Add_table from '../Api_Logs/Add_table.js'
import Edit from '../Api_Logs/Edit.js'
import Delete from '../../../components/Delete.js';
import apiClient from '../../../api/apiClient.js';
import { RiFileExcel2Line } from 'react-icons/ri';
import AFFilter from './Filter.js';
import authServices from '../../../services/AuthServices.js';
import RejectModal from './RejectModal.js';
import ApproveModal from './Approve_modal.js';

import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import { TfiReload } from 'react-icons/tfi';

const BalanceUpdateRequest = () => {

  const [LogicalFlag, setLogicalFlag] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const toggleModal = () => {
    setShowModal(!showModal);
  };


  //***************************************  this is for Edit modal *************************************************

  const [editModal, seteditModal] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);

  const toggleeditModal = (invoiceId) => {
    setSelectedInvoice(invoiceId);
    seteditModal(!editModal);
  };


  //**************************** GetAll Data Fetch ka function *******************************************************

  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const loader = (display) => { dispatch(CustomLoader(display)) }

  const [Records, setRecords] = useState([]);

  const [currentPage, setCurrentPage] = useState(0); // Current page
  const [totalPages, setTotalPages] = useState(1); // Total pages
  const itemsPerPage = 8; // Number of items per page

  const token = authServices.getToken();
  const fetchRecords = async (page) => {

    try {

      loader('enable');
      const response = await apiClient.get(`/api/admin/balance_update_request/getByStatus?status=${'pending'}&pageNumber=${page}&pageSize=${itemsPerPage}`, {

        headers: {
          'access_token': token,
        },
      });
      if (response.data.Status === "SUCCESS") {

        setRecords(response.data.data.records);
        setTotalPages(response.data.data.totalPages);
      }
      else {
        console.log(response.data.message)
      }
    }
    catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }

    finally {
      loader('disable');
    }

  };

  // Date Picker useEffect
  useEffect(() => {
    loader('disable');

    if (inputRef.current) {
      const fp = flatpickr(inputRef.current, {
        mode: "range",
        onChange: (selectedDates) => {
          if (selectedDates.length === 2) {
            setSelectedDate(selectedDates); // Set the selected date range

            setAFFromDate(null)
            setAFToDate(null)
            setLogicalFlag(true);
          }
        },
      });

      return () => {
        fp.destroy();
      };
    }
  }, []);


  // Pagination handlers
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage); // Update page
  };


  // Pagination component
  const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    const pages = [];

    // Add first 2 pages
    for (let i = 0; i < Math.min(2, totalPages); i++) {
      pages.push(i);
    }

    // Add the current page if it's between first 2 and last 2 pages
    if (currentPage > 1 && currentPage < totalPages - 2) {
      pages.push(currentPage);
    }

    // Add last 2 pages
    for (let i = Math.max(totalPages - 2, 2); i < totalPages; i++) {
      pages.push(i);
    }


    // Previous button condition
    const previousPage = () => {
      if (currentPage > 0) {
        onPageChange(currentPage - 1);
      }
    };

    // Next button condition
    const nextPage = () => {
      if (currentPage < totalPages - 1) {
        onPageChange(currentPage + 1);
      }
    };

    // pagination Buttons Next & Previous
    return (
      <nav>
        <ul className="pagination">

          {/* Previous Button */}
          <li className={`page-item ${currentPage === 0 ? 'disabled' : ''}`}>
            <button onClick={previousPage} className="page-link">
              Previous
            </button>
          </li>

          {pages.map((page) => (
            <li key={page} className={`page-item ${page === currentPage ? 'active' : ''}`}>
              <button onClick={() => onPageChange(page)} className="page-link">
                {page + 1}
              </button>
            </li>
          ))}

          {/* Next Button */}
          <li className={`page-item ${currentPage === totalPages - 1 ? 'disabled' : ''}`}>
            <button onClick={nextPage} className="page-link">
              Next
            </button>
          </li>
        </ul>
      </nav>
    );
  };


  //****************************************  flatpickr code Date filter  ***********************************************


  const [selectedDate, setSelectedDate] = useState([]);

  const [AFFromDate, setAFFromDate] = useState(null);
  const [AFToDate, setAFToDate] = useState(null);

  const formatDate = (date) => {

    if (!date) return '';

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;

  };

  const Flatpickr_Filter = async (page) => {

    if (LogicalFlag) {
      page = 0;
      setCurrentPage(0);
    }

    const formattedFromDate = formatDate(new Date(selectedDate[0])),
      formattedToDate = formatDate(new Date(selectedDate[1]));


    try {
      setRecords([]);
      loader('enable');

      const response = await apiClient.get(`/api/admin/balance_update_request/DateRangePagedWithPagination?fromDate=${formattedFromDate}&toDate=${formattedToDate}&pageNumber=${page}&pageSize=${itemsPerPage}`
        , {

          headers: {
            'access_token': token,
          },

        });
      if (response.data.Status === "SUCCESS") {

        setTotalPages(response.data.data.totalPages);
        setRecords(response.data.data.records);

      }
      else {
        console.log(response.data.message)
      }
    }
    catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }

    finally {
      setLogicalFlag(false);
      loader('disable');
    }
  };


  //***************************************** Delete List Records  ***************************************************************

  const [openModal, setOpenModal] = useState(false);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);

  const handleDeleteClick = (invoiceId) => {
    setSelectedInvoiceId(invoiceId);
    setOpenModal(true); // Open the modal when delete is clicked
  };


  const handleConfirmDelete = async (invoiceId) => {
    try {
      loader('enable');
      const response = await apiClient.delete(`/api/admin/api_logs/${selectedInvoiceId}`, {

        headers: {
          'access_token': token,
        },

      });
      if (response.data.Status === "SUCCESS") {

      }
      else {
        console.log(response.data.message)
      }
    }
    catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      fetchRecords(currentPage);
      loader('disable');
      setOpenModal(false);
    }
  };


  const handleCloseModal = () => {
    setOpenModal(false); // Close the modal if user cancels
  };

  // Excel File Downlode  ***********************************************************************************************************

  const ExcelFileDownload = async () => {
    try {
      loader('enable');

      const response = await apiClient.get(`/api/admin/api_logs/download`, {
        responseType: 'blob',

        headers: {
          'access_token': token,
        },
      });
      // if (response.data.Status === "SUCCESS") {

      // Create a link to download the file
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;

      // Set the file name you want to download as
      link.setAttribute('download', 'Balance_Request.xlsx'); // Change the file name if needed
      document.body.appendChild(link);
      link.click();

      // Clean up the link element
      link.remove();

      // }
      // else {
      //   console.log(response.data.message)
      // }
    } catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      loader('disable');
    }
  };



  //*************************************  This is for Advance filter **************************************************

  const [FilterModal, setFilterModal] = useState(false);

  const [selectedOption, setselectedOption] = useState(null);
  const [inputValue, setinputValue] = useState(null);

  const toggleFilterModal = () => {
    setFilterModal(!FilterModal);
  };

  const handleSendDataToParent = (fromDate, toDate, column, value) => {
    setAFFromDate(fromDate)
    setAFToDate(toDate)
    setselectedOption(column)
    setinputValue(value)

    setSelectedDate([]);
    setLogicalFlag(true);

  };

  const applyFilter = async (page) => {

    if (LogicalFlag) {
      page = 0;
      setCurrentPage(0);
    }

    try {
      setRecords([]);
      loader('enable');

      const pageNumber = page;
      const pageSize = itemsPerPage;

      const fromDate = AFFromDate;
      const toDate = AFToDate;
      const column = selectedOption;
      const value = inputValue;

      const response = await apiClient.get(`/api/admin/api_logs/filter`, {
        params: {
          pageNumber,
          pageSize,
          fromDate,
          toDate,
          column,
          value,
        },

        headers: {
          'access_token': token,
        },

      });

      if (response.data.Status === "SUCCESS") {

        setRecords(response.data.data.records);
        setTotalPages(response.data.data.totalPages);

      }
      else {
        console.log(response.data.message)
      }
    }
    catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      setLogicalFlag(false);
      loader('disable');
    }

  };
  // ************************************************************************************************************************************

  useEffect(() => {

    if (selectedDate[0] && selectedDate[1]) {
      Flatpickr_Filter(currentPage);

    }
    else if (AFFromDate && AFToDate) {
      applyFilter(currentPage);

    }
    else {
      fetchRecords(currentPage);

    }
  }, [currentPage, AFFromDate, AFToDate, selectedDate]);


  // **********************************************************************************************************************

  const displayedData = Records;

  // *************************************************  This For CheckBox  **********************************************************

  const [selectedItems, setSelectedItems] = useState([]);

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const allIds = displayedData.map(invoice => invoice.id);
      setSelectedItems(allIds);
    } else {
      setSelectedItems([]);
    }
  };

  const handleSelectItem = (event, id) => {
    if (event.target.checked) {
      setSelectedItems([...selectedItems, id]);
    } else {
      setSelectedItems(selectedItems.filter(item => item !== id));
    }
  };

  // ************************************************ Modal code ****************************************************************

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [SelectedBalId, setSelectedBalId] = useState(null);
  const [SelectedBankid, setSelectedBankid] = useState(null);

  const handleRejectClick = (invoiceId, bankId) => {
    setSelectedBalId(invoiceId);
    setSelectedBankid(bankId);
    setIsModalOpen(true) // Open the modal when delete is clicked
  };

  const handleDelete = async (remark) => {
    try {
      if (remark) {

        const response = await apiClient.post(`/api/admin/balance_update_request/balanceRequest`,
          {
            reqId: SelectedBalId,
            remark: "Admin : " + remark,
            status: "reject",
            bank: {
              id: SelectedBankid
            },
          },
          {
            headers: {
              access_token: token,
              "Content-Type": "application/json"
            }
          }
        );
        if (response.data.Status === "SUCCESS") {
          toast.success(response.data.message);
          setIsModalOpen(false);

        }
        else {
          toast.error(response.data.message);
        }
      } else {
        toast.error("Please Add Remark !!");

      }

    } catch (error) {
      toast.error(error.response.data.message);
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      fetchRecords(currentPage);
    }
  };
  // ***********************************************************************************************************************************
  const [isModalOpen2, setIsModalOpen2] = useState(false);

  const [SelectedBalId2, setSelectedBalId2] = useState(null);
  const [SelectedBankid2, setSelectedBankid2] = useState(null);

  const handleApproveClick = (invoiceId, bankId) => {
    setSelectedBalId2(invoiceId);
    setSelectedBankid2(bankId);
    setIsModalOpen2(true) // Open the modal when delete is clicked
  };

  const handleApprove = async () => {
    try {
      const response = await apiClient.post(`/api/admin/balance_update_request/balanceRequest`,
        {
          reqId: SelectedBalId2,
          remark: "",
          status: "approve",
          bank: {
            id: SelectedBankid2
          },
        },
        {
          headers: {
            access_token: token,
            "Content-Type": "application/json"
          }
        }
      );
      if (response.data.Status === "SUCCESS") {
        toast.success(response.data.message);

      }
      else {
        toast.error(response.data.message);

      }
    } catch (error) {
      toast.error(error.response.data.message);
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      fetchRecords(currentPage);
      setIsModalOpen2(false);
    }
  };

  // Reset filter and fetch original data
  const resetFilter = () => {
    setSelectedDate([]);
    fetchRecords(0);
    setCurrentPage(0);
    setAFFromDate(null)
    setAFToDate(null)

    // Reset flatpickr calendar dates
    if (inputRef.current && inputRef.current._flatpickr) {
      inputRef.current._flatpickr.clear();
    }
  };

  return (
    <>

      <Add_table show={showModal} toggle={toggleModal} refreshData={fetchRecords} AddcurrentPage={currentPage} />
      <Edit edit={editModal} toggle_Edit={toggleeditModal} invoiceId={selectedInvoice}
        refreshData={fetchRecords} AddcurrentPage={currentPage} />

      <AFFilter
        Filter={FilterModal}
        toggle_Filter={toggleFilterModal}
        SendDataToParent={handleSendDataToParent}

      />

      <RejectModal
        show={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={handleDelete}
        message="Do you really want to Reject ?"
      />

      <ApproveModal
        show={isModalOpen2}
        onClose={() => setIsModalOpen2(false)}
        onConfirm={handleApprove}
        message="Do you really want to Approve ?"
      />

      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between">

                <div className="mb-4">

                  {/* <button
                    onClick={toggleModal}
                    type="button"
                    className="btn btn-light waves-effect waves-light"
                  >

                    + ADD
                  </button> */}

                </div>

                <div className="d-flex align-items-center gap-1 mb-4">
                  <div className="input-group datepicker-range">
                    <input
                      ref={inputRef}
                      className="form-control flatpickr-input input"
                      type="text"
                      value={
                        selectedDate.length === 2 && selectedDate[0] && selectedDate[1]
                          ? `${formatDate(selectedDate[0])} - ${formatDate(selectedDate[1])}`
                          : "" // Empty input initially
                      }
                      onChange={(e) => {
                        const dateRange = e.target.value.split(" - ");
                        const startDate = dateRange[0] ? new Date(dateRange[0].split('-').reverse().join('-')) : null;
                        const endDate = dateRange[1] ? new Date(dateRange[1].split('-').reverse().join('-')) : null;

                        setSelectedDate([startDate, endDate]);

                      }}
                      placeholder="Filter By Date"
                    />

                    <button className="input-group-text" id="date1" onClick={resetFilter}>
                      <TfiReload />
                    </button>

                  </div>
                  {/* <div className="dropdown">
                    <a
                      className="btn btn-link text-muted py-1 font-size-16 shadow-none dropdown-toggle"
                      href="#"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      < HiDotsHorizontal />
                    </a>
                    <ul className="dropdown-menu dropdown-menu-end">

                      <li>
                        <a className="dropdown-item" onClick={() => toggleFilterModal()}>

                          Filter
                        </a>
                      </li>

                      <li>
                        <button className="dropdown-item" onClick={ExcelFileDownload}>
                          <RiFileExcel2Line
                            style={{
                              fontSize: '20px',
                              marginLeft: '-0.50vw',
                              marginRight: '0.50vw',
                              marginTop: '-0.10vw',
                            }}
                          />
                          Excel File Download
                        </button>
                      </li>
                    </ul>
                  </div> */}
                </div>
              </div>
              {/* end row */}
              <div className="table-responsive ">
                <table
                  className="table table-bordered align-middle datatable dt-responsive table-check nowrap text-center"
                  style={{
                    borderCollapse: "collapse",
                    borderSpacing: "0 8px",
                    width: "100%"
                  }}
                >
                  <thead className='table-light'>
                    <tr className="bg-transparent">
                      {/* <th style={{ width: 5 }}>
                      <div className="form-check font-size-16">
                        <input
                          type="checkbox"
                          name="check"
                          className="form-check-input"
                          id="checkAll"
                          onChange={handleSelectAll}
                          checked={selectedItems.length === displayedData.length}
                        />
                        <label className="form-check-label" htmlFor="checkAll" />
                      </div>
                    </th> */}
                      {/* <th style={{ width: 100 }}>_ID_</th> */}
                      <th style={{ width: 100 }}>Action</th>
                      <th style={{ width: 100 }}>Amount</th>
                      <th style={{ width: 100 }}>Bank&nbsp;Ref&nbsp;Id</th>
                      <th style={{ width: 100 }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Date&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                      <th style={{ width: 100 }}>Order&nbsp;Id</th>
                      <th style={{ width: 100 }}>&nbsp;&nbsp;Remark&nbsp;&nbsp;</th>
                      <th style={{ width: 100 }}>Status</th>
                      <th style={{ width: 100 }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Time&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                      <th style={{ width: 100 }}>Update&nbsp;Date</th>
                      <th style={{ width: 100 }}>&nbsp;Parent&nbsp;</th>
                      <th style={{ width: 100 }}>&nbsp;Bank&nbsp;</th>
                      <th style={{ width: 100 }}>&nbsp;User&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    {displayedData.length > 0 ? (
                      <>
                        {displayedData.map(invoice => (
                          <tr key={invoice.id}>
                            {/* <td>
                            <div className="form-check font-size-16">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id={`check-${invoice.id}`}
                                checked={selectedItems.includes(invoice.id)}
                                onChange={(e) => handleSelectItem(e, invoice.id)}
                              />
                              <label className="form-check-label" htmlFor={`check-${invoice.id}`} />
                            </div>
                          </td> */}
                            {/* <td>
                            <a
                              className="text-body fw-medium"
                            >{invoice.id}
                            </a>
                          </td> */}
                            <td>
                              <div className='d-flex justify-content-evenly mt-1 mb-1'>
                                <button
                                  className="btn btn-success me-1"
                                  type="button"
                                  onClick={() => handleApproveClick(invoice.id, invoice?.bankId?.id)}>
                                  Approve
                                </button>
                                <button
                                  className="btn btn-danger ps-3 pe-3"
                                  type="button"
                                  onClick={() => handleRejectClick(invoice.id, invoice?.bankId?.id)}>
                                  Reject
                                </button>
                              </div>
                            </td>
                            <td>{invoice?.amount || '--'}</td>
                            <td>{invoice?.bankRefId || '--'}</td>
                            <td>{invoice?.date || '--'}</td>
                            <td>{invoice?.orderId || '--'}</td>
                            <td>{invoice?.remark || '--'}</td>
                            <td>{invoice?.status || '--'}</td>
                            <td>{invoice?.time || '--'}</td>
                            <td>{invoice?.updateDate || '--'}</td>
                            <td>{invoice?.parentId?.name || '--'}</td>
                            <td>{invoice?.bankId?.banks || '--'}</td>
                            <td>{invoice?.userId?.name || '--'}</td>

                            {/* <td>
                            <div className="dropdown">
                              <button
                                className="btn btn-link font-size-16 shadow-none py-0 text-muted dropdown-toggle"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                < HiDotsHorizontal />
                              </button>
                              <ul className="dropdown-menu dropdown-menu-end">
                                <li>

                                  <button
                                    onClick={() => toggleeditModal(invoice.id)}
                                    type="button"
                                    className="btn waves-effect waves-light dropdown-item"
                                  >

                                    <i className="dropdown-item" /> Edit
                                  </button>

                                </li>

                                <li>
                                  <button className="btn waves-effect waves-light dropdown-item"
                                    onClick={() => handleDeleteClick(invoice.id)}
                                  >
                                    Delete
                                  </button>
                                  <Delete
                                    open={openModal}
                                    handleClose={handleCloseModal}
                                    handleConfirm={handleConfirmDelete}
                                    message="Are you sure you want to delete this invoice ?"
                                  />
                                </li>
                              </ul>
                            </div>
                          </td> */}
                          </tr>
                        ))}
                      </>
                    ) : (
                      <tr>
                        <td colSpan={11}>
                          <p className="text-center" >Record Not Found</p>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {/* end table responsive */}

              <div className='d-flex flex-row justify-content-end'>
                Showing {currentPage + 1} In to {totalPages} Entries
              </div>

              {/* Pagination */}

              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />

            </div>

            {/* end card body */}
          </div>
          {/* end card */}
        </div>
        {/* end col */}
      </div>


    </>

  );
};

export default BalanceUpdateRequest;
